import React from "react";
import {Col, FormGroup} from "reactstrap";
import Toggle from "react-toggle";
import PropTypes from "prop-types";
import HelpIcon from "../../HelpIcon/HelpIcon";

/** This component is wrapper around Toggle component of react-toggle library */

const ToggleCreator = (props) => {
  const {
    label,
    help_text,
    large = false,
    colSize = "6",
    testId = "toggle",
    ...rest
  } = props;

  return (
    <Col md={large ? "12" : colSize}>
      <FormGroup data-cy={testId}>
        <div>
          <label className="form-control-label" htmlFor="input-name">
            {label}
          </label>
          {help_text && <HelpIcon text={help_text} target={label} place="right" />}
        </div>
        <Toggle {...rest} />
      </FormGroup>
    </Col>
  );
};

ToggleCreator.propTypes = {
  /** Label for form field */
  label: PropTypes.string,
  /** If this prop is set to true then this component will take 100% width of parent component */
  large: PropTypes.bool,
  /** This prop will be passed as colSize to reactstrap Col component */
  colSize: PropTypes.string,
  /** If value is passed for this prop this will be shown as tooltip when hovered on help icon */
  help_text: PropTypes.string,
  /** Id which will be passed as data-cy attribute to form control component */
  testId: PropTypes.string,
};

export default ToggleCreator;
